import TableList from "@components/templates/tablelist";
import {
    HttpBespeakList,
    HttpBespeakWarehouses,
    HttpDelBespeak,
    HttpDelBespeaks,
    HttpCancelBespeaks,
    HttpDeliverBespeak,
    HttpExportBespeak,
    HttpBespeakSpan,
    HttpCopyOrderBespeak,
    HttpManageCancelBespeak
} from "@/service/bespeak";
import { mapGetters } from "vuex";
import comIndex from './detail'
export default {
    mixins: [TableList],
    components: {
        comIndex
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs:{ show: true },
            spanTabs: { show: true },
            Searchs: {
                show: true,
                labelWidth: 150
            },
            Plugins: { show: true },
            warehouseList: [],
        };
    },
    created() {
        this.getWarehouse();
    },
    methods: {
        ajaxRequest: HttpBespeakList,
        interceptRequest(params) {
            if(params.search.IN_containerNo){
                let containerdNo = params.search.IN_containerNo.replace(/，/g, ",");
                params.search.IN_containerNo = containerdNo.split(',').filter(item=>item.length>0)
            }
            return params;
        },
        spanAjaxRequest () {
            return HttpBespeakSpan({ orgRoleName: this.formData.orgRoleName });
        },
        getWarehouse() {
            const isManage = this.formData.orgRoleName === "WAREHOUSE";
            HttpBespeakWarehouses({
                orgRoleName: this.formData.orgRoleName
            }).then(res => {
                this.warehouseList = res.data.map(item => {
                    const { id, title, code } = item;
                    return {
                        value: isManage ? code : id,
                        label: `${title}(${code})`
                    };
                });
            });
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning(
                        "Please select at least one data"
                    );
            }
            // console.log(this.$route,'this.$routethis.$routethis.$route')
            const orgRoleName = this.formData.orgRoleName,
                routeName = this.$route.name,
                routeUpdate = routeName + "Update",
                routeQuery = routeName + "Query";
            switch (type) {
                case "add":
                    this.$router.push({
                        name: routeUpdate,
                        params: { type: "add" },
                        query: { orgRoleName }
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: routeUpdate,
                        params: { type: "edit" },
                        query: { id: params, orgRoleName }
                    });
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        orgName:orgRoleName,
                        showFooter:false
                    }
                    break;
                case "queryBlank":
                    {
                        let url = this.$router.resolve({
                            name: routeQuery,
                            // params: { type: "query" },
                            query: { id: params, orgRoleName }
                        });
                        window.open(url.href, "_blank");
                    }
                    break;

                case "batchdel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { ids: params, orgRoleName },
                        title: "Batch Delete",
                        ajaxRequest: HttpDelBespeaks
                    };
                    break;
                case "del":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params, orgRoleName },
                        title: "Delete",
                        ajaxRequest: HttpDelBespeak
                    };
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: "Batch Cancel",
                        params: { ids: params, orgRoleName },
                        ajaxRequest: HttpCancelBespeaks
                    };
                    break;
                case "copyorder":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: "Copy",
                        params: { id: params, orgRoleName },
                        ajaxRequest: HttpCopyOrderBespeak
                    };
                    break;
                case "manageCancel":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: "Batch Cancel",
                        params: { id: params, orgRoleName },
                        ajaxRequest: HttpManageCancelBespeak,
                        formdata: [
                            {
                                label: "Remark",
                                tag: "vTextarea",
                                labelWidth: "auto",
                                key: "remark",
                                span: 24,
                            }
                        ]
                    };
                    break;
                case "deliver":
                    this.operate = {
                        show: true,
                        alert: "info",
                        width: 'middle',
                        title: "Delivered Date",
                        params: { id: params },
                        ajaxRequest: HttpDeliverBespeak,
                        showDesc: false,
                        formdata: [
                            {
                                label: "Delivered Date",
                                tag: "vDatepicker",
                                key: "deliveredDate",
                                span: 24,
                                props: {
                                    format: 'yy-mm-dd',
                                },
                            },
                            {
                                label: "Remark",
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                required: false,

                            }
                        ]
                    };
                    break;
                case "export":
                    this.handleWebfs(HttpExportBespeak, { ...this.formData }, { executor: 'request', download: true });
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, status, deliverDate } = row,
                isNoManage = this.formData.orgRoleName !== "WAREHOUSE",
                show = status == 0 && isNoManage,
                isDeliver = ( status == 4) && isNoManage && !deliverDate;
            return [
                {
                    label: "View",
                    params: id,
                    operate: "query",
                    show: true
                },
                {
                    label: "Edit",
                    params: id,
                    operate: "edit",
                    show
                },
                {
                    label: "Deliver",
                    params: id,
                    operate: "deliver",
                    show: isDeliver
                },
                {
                    label: "Delete",
                    params: id,
                    operate: "del",
                    show
                },
                {
                    label: "Copy",
                    params: id,
                    operate: "copyorder",
                    show:status == 5
                },
                {
                    label: "Cancel",
                    params: id,
                    operate: "cancel",
                    show:(status==1||status==2|| status == 3) && isNoManage
                },
                {
                    label: "Cancel",
                    params: id,
                    operate: "manageCancel",
                    show:(status==2||status==3) && this.formData.orgRoleName == "WAREHOUSE"
                }
            ];
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusproductList', 'getProductList']),
        TabsData() {
            return [
                {
                    name: "ALL",
                    key: "EQ_status",
                    val: null,
                    spanKey: "ALL",
                },
                {
                    name: "Draft",
                    key: "EQ_status",
                    val: "0",
                    theme: "primary",
                    spanKey: "Draft"
                },
                {
                    name: "Pending",
                    key: "EQ_status",
                    val: "1",
                    theme: "info",
                    spanKey: "Pending to Approval"
                },
                {
                    name: "Approved",
                    key: "EQ_status",
                    val: "2",
                    theme: "success",
                    spanKey: "Approved"
                },
                {
                    name: "Rejected",
                    key: "EQ_status",
                    val: "3",
                    theme: "warning",
                    spanKey: "Rejected"
                },
                {
                    name: "Arrived",
                    key: "EQ_status",
                    val: "6",
                    spanKey: "Arrived"
                    // theme: "error"
                },
                {
                    name: "Unloaded",
                    key: "EQ_status",
                    val: "4",
                    spanKey: "Unloaded"
                    // theme: "info"
                },
                {
                    name: "Cancelled",
                    key: "EQ_status",
                    val: "5",
                    spanKey: "Cancelled"
                    // theme: "error"
                }
            ];
        },
        ToolsData() {
            return this.formData.orgRoleName === "WAREHOUSE"
                ? [
                    {
                        name: "Export",
                        operate: "export",
                        theme: "info",
                    }
                ]
                : [
                    {
                        name: "New",
                        operate: "add",
                        theme: "primary"
                    },
                    {
                        name: "Export",
                        operate: "export",
                        theme: "info",
                    },
                    {
                        name: "Batch Delete",
                        operate: "batchdel",
                        more: true,
                        batch: true
                    },
                    {
                        name: "Batch Cancel",
                        operate: "cancel",
                        more: true,
                        batch: true
                    }
                ];
        },
        SearchsData() {
            const isManage = this.formData.orgRoleName === "WAREHOUSE";
            const isCustomer = this.formData.orgRoleName === "MERCHANT";
            return [
                {
                    label: "Warehouse",
                    tag: "vSelect",
                    key: isManage ? "IN_orgWarehouseCode" : "IN_orgWarehouseId",
                    show: true,
                    options: this.warehouseList,
                    props: {
                        multiple: true,
                        filterable: true
                    },
                    show: true,
                    style: 'width: 170px',
                },
                {
                    label: "Inbound Plan No.",
                    tag: "vInput",
                    key: "CN_inboundNos",
                    props: {
                        placeholder: 'If there are multiple items separated by commas in English'
                    },
                    show: true,
                    style: 'width: 170px',
                },
                {
                    label: "Container No.",
                    tag: "vInput",
                    key: "IN_containerNo",
                    // options:[],
                    props: {
                        placeholder: 'If there are multiple items separated by commas in English'
                    },
                    show: true,
                    style: 'width: 170px',
                },
                {
                    label: "Scheduled Delivery Time",
                    tag: "vDatepicker",
                    style: "width:200px",
                    key: "BT_reserveInboundDate",
                    props: {
                        format: "yy-mm-dd ~ yy-mm-dd",
                        confirm: false,
                    },
                    formItem: {
                        labelWidth: 150
                    }
                },
                {
                    label: "Actual Arrival Time",
                    tag: "vDatepicker",
                    style: "width:200px",
                    key: "BT_warehouseArriveTime",
                    props: {
                        format: "yy-mm-dd ~ yy-mm-dd",
                        confirm: false,
                    },
                    formItem: {
                        labelWidth: 150
                    }
                },
                {
                    label: "Container Empty Time",
                    tag: "vDatepicker",
                    style: "width:200px",
                    key: "BT_containerEmptyTime",
                    props: {
                        format: "yy-mm-dd ~ yy-mm-dd",
                        confirm: false
                    },
                    formItem: {
                        labelWidth: 150
                    }
                },
                {
                    label: "Reservation No.",
                    tag: "vInput",
                    key: "EQ_reserveInboundNo",
                    style: "width:200px",
                },
                {
                    label: "Customer Organization",
                    key: 'EQ_organizationId',
                    tag: 'vSelect',
                    options: this.getSelfmanageorgList,
                    hidden: isManage,
                    show: true,
                    props: {
                        filterable: true,
                    },
                    style: "width:200px",
                },
                {
                    label: "Project",
                    key: 'CN_lineNames',
                    tag: 'vSelect',
                    options: (isManage ? this.getCusproductList : this.getProductList).map(item => {
                        return {
                            value: item.attach.name,
                            label: item.label
                        }
                    }),
                    hidden: !(isCustomer||isManage),
                    props: {
                        filterable: true,
                    },
                    style: "width:200px",
                },
                {
                    label: "Inbound Type",
                    tag: "vSelect",
                    key: "EQ_inboundType",
                    options: [
                        {
                            label: "Purchase",
                            value: 0
                        },
                        {
                            label: "Transfer",
                            value: 1
                        }
                    ],
                    style: "width:200px",
                },
                {
                    label: "Cargo Form",
                    tag: "vSelect",
                    key: "CN_goodTypeCode",
                    options: [
                        {
                            label: "FCL(Container)",
                            value: "FCL"
                        },
                        {
                            label: "LTL(Truck)",
                            value: "LTL"
                        },
                        {
                            label: "Express",
                            value: "Express"
                        }
                    ],
                    style: "width:200px",
                },
                {
                    label: "Document Type",
                    tag: "vSelect",
                    key: "EQ_bookingType",
                    options: [
                        {
                            label: "VAS",
                            value: "0"
                        },
                        {
                            label: "Nomal",
                            value: "1"
                        },
                    ],
                    style: "width:200px",
                },
            ];
        },
        columns() {
            const isManage = this.formData.orgRoleName === "WAREHOUSE";
            return [
                {
                    type: "selection",
                    width: 40,
                    align: "center",
                    formName: "id"
                },
                {
                    title: "Operation",
                    width: 90,
                    render: this.getOperateNodes
                    // render:(h,{row})=>{
                    //     return <vButton theme="primary" onClick={this.handleOperates.bind(this,row.id,'query')}>查看</vButton>
                    // }
                },
                {
                    title: "Reservation No.",
                    key: "reserveInboundNo",
                    render: (h, { row }) => {
                        return <div>
                        <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.reserveInboundNo}</a>
                        <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        <div v-show={row.yqnFlag == 1}><img style="width:20px" src="/img/yqnlogo.png"></img></div>
                    </div>
                        // (
                        //     <a
                        //         theme="primary"
                        //         onClick={this.handleOperates.bind(
                        //             this,
                        //             row.id,
                        //             "query"
                        //         )}
                        //     >
                        //         {row.reserveInboundNo}
                        //     </a>
                        // );
                    }
                },
                {
                    title: "Status",
                    key: "status",
                    width: 130,
                    render: (h, { row }) => {
                        const { name, theme } =
                            this.TabsData.find(function (item) {
                                return item.val == row.status;
                            }) || {};
                        return (
                            <vButton
                                ghost
                                theme={theme}
                                size="small"
                                class="cursor-default"
                                style="min-width:70px;"
                            >
                                {name}
                            </vButton>
                        );
                    }
                },
                {
                    title: 'Organization',
                    key: 'organizationId',
                    width: isManage ? undefined : 0,
                    render: (h, { row }) => this.findRenderLabel(this.getSelfmanageorgList, row.organizationId)
                },
                {
                    title: "Project/Warehouse/Inbound Type",
                    render:(h,{row})=>{
                        return <div>
                            <div>{row.lineNames || '--'}</div>
                            <div>{row.orgWarehouseCode}({row.warehouseTitle})</div>
                            <div>{row.inboundType == 1 ? "Transfer" : "Purchase"}</div>
                        </div>
                    },
                },
                {
                    title: "Inbound Plan No.",
                    key: "inboundNos"
                },
                {
                    title: "Cargo Form/Container No.",
                    key: "goodTypeName",
                    render:(h,{row})=>{
                        return <div>
                            <div>{row.goodTypeName || '--'}</div>
                            <div>{row.containerNo || '--'}</div>
                        </div>
                    },
                },
                {
                    title: "Pallet QTY",
                    key: "trayCount",
                    width: 90,
                    render: (h, { row }) => {
                        return row.trayCount || '--';
                    }
                },
                {
                    title:'Document Type',
                    key: "bookingType",
                    width: 90,
                    render: (h, { row }) => {
                        return <div>
                        <div v-show={row.bookingType == '0'} class="color-success">VAS</div>
                        <div v-show={row.bookingType == '1'}  class="color-primary">Nomal</div>
                    </div>
                    }
                },
                {
                    title: "Scheduled Delivery Time",
                    key: "reserveInboundDate",
                    sortable:true,
                    render: (h, { row }) => {
                        return row.reserveInboundDate || '--';
                    }
                },
                {
                    title: 'Actual Arrival Time',
                    key: 'warehouseArriveTime',
                    sortable: true,
                    render: (h, { row }) => {
                        return row.warehouseArriveTime || '--';
                    }
                },
                {
                    title: "Container Empty Time",
                    key: "containerEmptyTime",
                    sortable:true,
                    render: (h, { row }) => {
                        return row.containerEmptyTime || '--';
                    }
                },
                {
                    title: "Update Time",
                    key: "updatedAt",
                    render: (h, { row }) => {
                        return row.updatedAt || '--';
                    }
                }
            ];
        }
    }
};
